var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "node",
      class: {
        "main-node": _vm.mainNode,
        dragging: _vm.isDragging,
        "dragging-above": _vm.draggingAbove,
        "something-dragged": _vm.somethingIsBeingDragged,
      },
      style: _vm.style,
      on: {
        mouseup: function ($event) {
          return _vm.onDropInRoot($event)
        },
        touchend: function ($event) {
          return _vm.onDropInRoot($event)
        },
        mouseenter: function ($event) {
          return _vm.onDragEnter()
        },
        mouseleave: function ($event) {
          return _vm.onDragLeave()
        },
      },
    },
    [
      !_vm.mainNode
        ? _c(
            "div",
            { staticClass: "node-name" },
            [
              _c(
                "span",
                {
                  directives: [{ name: "long-touch", rawName: "v-long-touch" }],
                  staticClass: "handle",
                  on: {
                    "long-touch": function ($event) {
                      return _vm.onHandleLongTouch($event)
                    },
                    mousedown: function ($event) {
                      return _vm.onHandleMouseDown($event)
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "ellipsis-v" } })],
                1
              ),
              _c(
                "div",
                { staticClass: "and-or" },
                [
                  !_vm.isFirstNode
                    ? _c(
                        "w-link",
                        {
                          attrs: {
                            disabled: _vm.somethingIsBeingDragged,
                            value: _vm.node.isOr,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setIsOr(!_vm.node.isOr)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.andOrText))]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" " + _vm._s(_vm.nodeName) + " "),
              _c("w-spacer"),
              !_vm.node.isGroup
                ? _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("edit-filter"),
                          expression: "$ct('edit-filter')",
                        },
                      ],
                      staticClass: "warning",
                      attrs: {
                        disabled: _vm.somethingIsBeingDragged,
                        flat: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.editFilter()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "pen" } })],
                    1
                  )
                : _vm._e(),
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("remove-filter"),
                      expression: "$ct('remove-filter')",
                    },
                  ],
                  staticClass: "danger",
                  attrs: { disabled: _vm.somethingIsBeingDragged, flat: "" },
                  on: {
                    click: function ($event) {
                      return _vm.removeFilter()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "trash" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.node.isGroup
        ? _c(
            "div",
            {
              staticClass: "children",
              class: {
                "drop-target":
                  _vm.childrenDragDepth > 0 && _vm.draggingIsInChild == 0,
              },
              on: {
                mouseenter: function ($event) {
                  return _vm.onChildrenDragEnter()
                },
                mouseleave: function ($event) {
                  return _vm.onChildrenDragLeave()
                },
              },
            },
            _vm._l(_vm.node.children, function (childNode, i) {
              return _c("app-human-filter-list-edit-node", {
                key: childNode.key,
                attrs: {
                  node: childNode,
                  model: _vm.model,
                  browse: _vm.browse,
                  "parent-node": _vm.node,
                  "is-first-node": i == 0,
                  "something-is-being-dragged": _vm.somethingIsBeingDragged,
                },
                on: {
                  "drag-drop": (parent, child) =>
                    _vm.$emit("drag-drop", parent, child),
                  "drag-start": (node, parent) =>
                    _vm.$emit("drag-start", node, parent),
                  "drag-stop": function ($event) {
                    return _vm.$emit("drag-stop")
                  },
                  delete: function ($event) {
                    return _vm.removeNode(i)
                  },
                  edit: function ($event) {
                    return _vm.onEdit($event)
                  },
                  "emit-changes": function ($event) {
                    return _vm.$emit("emit-changes")
                  },
                  "drag-enter": function ($event) {
                    _vm.draggingIsInChild++
                  },
                  "drag-leave": function ($event) {
                    _vm.draggingIsInChild--
                  },
                },
              })
            }),
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }